/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Grid, Paper, Stack, Button, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useState, useEffect } from "react";

import { useAppBarHeight } from '../../../common/CustomHooks';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers';
import ChartCashRegisterReport from '../components/ChartCashRegisterReport';
import TableCashRegister from '../components/TableCashRegister';

const ReportsCashRegisterRoute = (): JSX.Element => {

    const { organizationId } = useParams();

    const theme = useTheme();

    const { t, i18n } = useTranslation();

    //##########################################################################################################

    const [periodGenerate, setPeriodGenerate] = useState<Date | null>(new Date());
    const [period, setPeriod] = useState("week");

    //###############################################################################################################################################
    //###############################################################################################################################################
    //########################################################API Calls and useEffects###############################################################
    useEffect(() => {
        let isMounted = true; //Avoid memory leaks. Async function running after dismount.
        //const service = new SourceDocumentService();

        const getData = async () => {

        };
        //Close current window when searching for something new
        getData();

        return () => { isMounted = false };
    }, []);

    //###############################################################################################################################################
    //###############################################################################################################################################
    
    //###############################################################################################################################################
    //###############################################################################################################################################
    const appBarHeight = useAppBarHeight();
    //########################################################################################
    //########################################################################################
    return <main>
        <Grid container component={Paper} direction="column" wrap="nowrap"
            sx={{
                paddingTop: theme.spacing(2),
                width: "100%",
                height: {
                    xs: "calc(100vh - " + appBarHeight + "px )",
                    xl: "calc(100vh)"
                },
                //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
            }}>
            <Grid container>
                <Grid padding={theme.spacing(4)}>
                    <Stack direction="row" spacing={theme.spacing(2)}>
                        <FormControl size="small" sx={{width:"8rem"}}>
                            <InputLabel id="select-date-type">{t('dateSearch.choosePeriod')}</InputLabel>
                            <Select
                                labelId="select-status-label"
                                id="select-status"
                                value={period}
                                label={t('dateSearch.choosePeriod')}
                                onChange={(e: SelectChangeEvent) => setPeriod(e.target.value)}
                            >
                                <MenuItem value={"week"}>{t("dateSearch.week")}</MenuItem>
                                <MenuItem value={"month"}>{t("dateSearch.month")}</MenuItem>
                            </Select>
                        </FormControl>
                        <DatePicker
                            views={period == "week" ? ["day"] : ["month"]}
                            label={period == "week" ? t("dateSearch.chooseWeek"): t("dateSearch.chooseMonth")}
                            value={periodGenerate}
                            onChange={(newValue) => { setPeriodGenerate(newValue) }}
                            slotProps={{ textField: { size: "small", helperText: null,} }}
                        />
                        <Button size="small" sx={{ width: "6rem" }} variant="contained" color="secondary">{t("reports.generate")}</Button>
                    </Stack>
                </Grid>
            </Grid>
            <Grid container minHeight="14rem">
                <ChartCashRegisterReport/>
            </Grid>
            <Grid container minHeight="30rem" paddingTop={theme.spacing(4)} overflow="hidden">
                <TableCashRegister groupType={''} />
            </Grid>
        </Grid>
    </main>

}
export default ReportsCashRegisterRoute;